/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const Order = require('../order');
const NonOrderItem = require('../non_order_item').default;
const User = require('../user/user');
const Hotel = require('../hotel/hotel').default;
const Project = require('../project/project').default;
const ProjectList = require('../project/project_list').default;
const TravelerList = require('../traveler/traveler_list');
const RentalCarList = require('../rental_car/rental_car_list').default;
const MarginTypeList = require('../organization/margin_type_list').default;
const TripRuleError = require('./trip_rule_error').default;
const TripRuleDistanceTimeInfo = require('./trip_rule_distance_time_info').default;
const TripStatus = require('./trip_status').default;
const SnoozedTodo = require('../snoozed_todo').default;
const moment = require('moment-timezone');
const TripApproveItemList = require('../trip_approve_item/trip_approve_item_list').default;
const { roundString } = require('../../util/string');

const makeLines = function (str) {
  if (str) {
    return str.split('\n');
  } else {
    return [];
  }
};

class Trip {
  static initClass() {
    this.prototype.textLength = 10;
  }
  constructor(args) {
    if (args == null) {
      args = {};
    }
    _.assign(this, args);
    // in_advance_approval.status:4 は、queueステータスでまだ承認待ちの待ちステータス
    // 承認ルートを事前に作る実装を入れた結果、フロントエンドに送られてくるようになった値だが、
    // フロントエンドでは不要な情報なので、間引く
    this.in_advance_approval = _.filter(args.in_advance_approval, i => i.status !== 4);
    this.serviceId = parseInt(dig(args, 'user', 'organization', 'service_id'));
    if (args.start_time) {
      this.startTime = moment(args.start_time);
    }
    if (args.end_time) {
      this.endTime = moment(args.end_time);
    }
    if (args.cache_start_time) {
      this.cacheStartTime = moment(args.cache_start_time);
    }
    if (args.cache_end_time) {
      this.cacheEndTime = moment(args.cache_end_time);
    }
    this.receivedAt = args.received_at_in_tokyo ? moment(args.received_at_in_tokyo) : undefined;
    this.showFee =
      typeof args['showFee'] === 'undefined'
        ? typeof dig(args, 'user', 'organization', 'show_fee') === 'undefined'
          ? true
          : dig(args, 'user', 'organization', 'show_fee')
        : args['showFee'];
    this.isInternalNumberRequired = args.isInternalNumberRequired;
    this.isProjectNameRequired = args.isProjectNameRequired;
    this.forbiddenRepositories = dig(args, 'user', 'organization', 'forbidden_repositories');
    this.marginTypes = dig(args, 'user', 'organization', 'margin_types');
    if (this.marginTypes) {
      this.marginTypes = new MarginTypeList(this.marginTypes);
    }
    this.hotel = new Hotel(this.hotel || this.hotel_json);
    // TODO: ts化する時に@projectを削除しても良いかもしれない
    // 使われてない？
    this.project = this.project ? new Project(this.project) : new Project({ id: 0, code: '', name: '' });
    this.projects = new ProjectList(this.projects);
    this.currentOrder = this.current_order;
    this.order = new Order(_.merge(this.current_order, this.orderOptions()), this);
    this.firstOrder = new Order(_.merge(this.first_order, this.orderOptions()), this);
    if (this.approved_order) {
      this.approvedOrder = new Order(_.merge(this.approved_order, this.orderOptions()), this);
    }
    this.appliedOrder = new Order(_.merge(this.applied_order, this.orderOptions()), this);
    this.nonOrderItems = args.non_order_items
      ? _.map(args.non_order_items, raw => new NonOrderItem(utils.snakeToCamelObject(raw)))
      : [];
    this.travelerInformations = new TravelerList(args.traveler_informations);
    this.currentTravelerInformations = new TravelerList(args.current_traveler_informations);
    this.travelers = this.currentTravelerInformations.list.length
      ? this.currentTravelerInformations
      : this.travelerInformations;
    this.rentalCars = new RentalCarList(this.rentalcar_requests, this.car_type_options);
    this.status = args.status;
    this.statusStr = this.status ? TripStatus[this.status] : '';
    this.approveStageCount = args.approve_stage_count;
    this.ruleErrors = _.map(args.cache_rule_errors, e => new TripRuleError(e)) || [];
    this.ruleDistanceTimeInfo =
      _.map(args.trip_distance_and_time_info, info => new TripRuleDistanceTimeInfo(info)) || [];
    this.progress = args.progress;
    this.internalNumber = args.internal_number || '';
    this.bakurakuWorkflowRequestId = args.bakuraku_workflow_request_id || '';
    this.bakurakuWorkflowRequestTitle = args.bakuraku_workflow_request_title || '';
    this.bakurakuWorkflowRequestNum = args.bakuraku_workflow_request_num || '';
    this.departments = args.charging_departments || [];
    this.expenseAccountTypeId = args.order;
    if (args.applicant) {
      if (args.applicant.department != null ? args.applicant.department.approval_authorities : undefined) {
        const { approval_authorities } = args.applicant.department;
        args.applicant.department.approval_authorities = _.filter(
          approval_authorities,
          aa => aa.workflow_id === args.workflow_id
        );
        this.applicant = new User(args.applicant);
      } else {
        this.applicant = new User(args.applicant);
      }
    }
    if (args.orders) {
      this.orders = args.orders
        .map(o => {
          return new Order(
            _.merge(o, { showFee: this.showFee, marginTypes: this.marginTypes, billing: args.billing })
          );
        })
        .sort(function (o1, o2) {
          if (o1.createdAt > o2.createdAt) {
            return 1;
          } else {
            return -1;
          }
        });
      for (var o of Array.from(this.orders)) {
        o.trip = this;
      }
    }
    this.flightApproveExpiredAt = args.flight_approve_expired_at
      ? moment(args.flight_approve_expired_at).tz('Asia/Tokyo').format('YYYY年MM月DD日HH時mm分')
      : null;

    if (this.order.orderItems.present != null) {
      this.showDepartmentDetail = this.checkHasShareOrAllDeptIdDifferent();
      this.showProjectDetail = this.checkHasShareOrAllProjectIdDifferent();
      this.showExpenseDetail = this.checkAllExpensesAccountTypeIdDifferent();
    } else {
      this.showDepartmentDetail = args.show_department_detail;
      this.showProjectDetail = args.show_project_detail;
      this.showExpenseDetail = args.show_expenses_account_type_detail;
    }

    // for /arrangement/todo_list
    this.latestUserMessage = args.latest_user_message;
    this.isUrgent = args.urgent || false;
    if (args.snoozed_todos) {
      this.snoozedTodos = _.map(args.snoozed_todos, raw => new SnoozedTodo(raw));
    }

    if (args.trip_approve_item) {
      const jsondata = JSON.parse(args.trip_approve_item.json);
      this.tripApproveItem = new TripApproveItemList(jsondata);
    }
    this.isTicketingRequestable = args.ticketing_requestable;
    this.isSeatReservationEnable = args.seat_reservation_enable;
    this.privateUse = args.private_use;
    this.travelerNameChanges = args.traveler_name_changes || [];
    this.hasUnreadReplyRequiredMessages = args.has_unread_reply_required_messages || false;
    this.receiptRevisionStatus = args.receipt_revision_status;
  }

  orderOptions() {
    return {
      serviceId: this.serviceId,
      showFee: this.showFee,
      marginTypes: this.marginTypes,
      trip: this
    };
  }

  dateRange() {
    // OUTDATED: 全てのケースでtripにstart_timeとend_timeを含まれるように修正したらこれ消す
    // 旅程が更新されて日程に変更があった場合にtripのstart_timeとend_timeと実際の日程にズレが生じるため
    // orderの内容からその都度計算することになった
    const start = this.cacheStartTime || this.startTime || this.order.startDate();
    const end = this.cacheEndTime || this.endTime || this.order.endDate();
    try {
      return moment(start).format('Y/MM/DD') + '〜' + moment(end).format('Y/MM/DD');
    } catch (e) {
      if (typeof bugsnagClient !== 'undefined') {
        bugsnagClient.notify(e, {
          metaData: {
            tripId: this.id,
            start,
            end
          },
          severity: 'error'
        });
      }
      return '';
    }
  }

  stayDays() {
    const o = this.order;
    if (!o) {
      return '';
    }

    const s = o.startDate();
    const e = o.endDate();
    if (!s || !e) {
      retrun('');
    }

    const days = e.diff(s, 'days');
    return `${days}泊${days + 1}日`;
  }

  userName() {
    return dig(this.user, 'name');
  }

  traveledUsers() {
    if (this.travelerInformations.list && this.travelerInformations.list.length > 0) {
      return this.travelerInformations.list;
    } else {
      return [this.user];
    }
  }

  travelerNames() {
    if (this.travelerInformations.list && this.travelerInformations.list.length > 0) {
      return this.travelerInformations.getTravelerNames();
    }
  }

  travelerShinkansenTypes() {
    if (this.travelerInformations.list && this.travelerInformations.list.length > 0) {
      return this.travelerInformations.getTravelerShinkansenTypes();
    }
  }

  departmentName() {
    if (this.applicant) {
      return dig(this.applicant, 'department', 'name');
    }
  }

  setDepartureLocation() {
    const elements = [];
    const items =
      (this.order.orderItems != null ? this.order.orderItems.length : undefined) > 0
        ? this.order.orderItems
        : this.nonOrderItems;
    for (var oi of Array.from(items)) {
      Array.prototype.push.apply(
        elements,
        _.filter(oi.elements, e => e.from !== undefined)
      );
    }

    this.departure_location = '';
    if ((this.order.orderItems != null ? this.order.orderItems.length : undefined) > 0) {
      return (this.departure_location = elements.length > 0 ? elements[0].from.name : '');
    } else if ((this.nonOrderItems != null ? this.nonOrderItems.length : undefined) > 0) {
      return (this.departure_location =
        __guard__(elements[0] != null ? elements[0].from : undefined, x => x.name) ||
        (elements[0] != null ? elements[0].boardingStation : undefined) ||
        '');
    }
  }

  originText() {
    if (!this.departure_location) {
      this.setDepartureLocation();
    }
    return roundString(this.departure_location, 30);
  }

  originTitle() {
    if (!this.departure_location) {
      return this.setDepartureLocation();
    } else if (this.departure_location.length > this.textLength) {
      return this.departure_location;
    }
  }

  setDistination() {
    if (!this.departure_location) {
      this.setDepartureLocation();
    }
    const from = this.departure_location;
    const elements = [];
    const items =
      (this.order.orderItems != null ? this.order.orderItems.length : undefined) > 0
        ? this.order.orderItems
        : this.nonOrderItems;

    for (var oi of Array.from(items)) {
      Array.prototype.push.apply(
        elements,
        _.filter(oi.elements, e => e.to !== undefined && e.to.name !== from)
      );
    }

    this.destination = '';
    if ((this.order.orderItems != null ? this.order.orderItems.length : undefined) > 0) {
      return (this.destination = elements.length > 0 ? _.map(elements, e => e.to.name).join('、') : '');
    } else if ((this.nonOrderItems != null ? this.nonOrderItems.length : undefined) > 0) {
      return (this.destination =
        elements.length > 0
          ? _.map(elements, e => (e.to != null ? e.to.name : undefined) || e.arrivalStation).join('、')
          : '');
    }
  }

  destinationText() {
    if (!this.destination) {
      this.setDistination();
    }
    return roundString(this.destination, 30);
  }

  destinationTitle() {
    if (!this.destination) {
      return this.setDistination();
    } else if (this.destination.length > this.textLength) {
      return this.destination;
    }
  }

  outwordLines() {
    return makeLines(dig(this.order, 'outword'));
  }

  homewordLines() {
    return makeLines(dig(this.order, 'homeword'));
  }

  flightLines() {
    return makeLines(dig(this.order, 'flight'));
  }

  hotelName() {
    return dig(this.order, 'hotel_name');
  }

  hotelNameTitle() {
    if (this.hotelName() && this.hotelName().length > this.textLength) {
      return this.hotelName();
    }
  }

  hotelCheckinDate() {
    return (
      dig(this.order, 'hotel_checkin_date') ||
      (dig(this.search_query, 'departure_time') && moment(dig(this.search_query, 'departure_time')))
    );
  }

  hotelCheckoutDate() {
    return (
      dig(this.order, 'hotel_checkout_date') ||
      (dig(this.search_query, 'return_time') && moment(dig(this.search_query, 'return_time')))
    );
  }

  hotelRoomType() {
    return dig(this.hotel_json, 'room_type');
  }

  outwordPrice() {
    if (this.order.orderItems.length > 0) {
      return this.order.outwordItem.price.totalPrice();
    } else {
      return dig(this.order, 'outword_price') || this.outword_price;
    }
  }

  outwordDate() {
    return dig(this.order, 'outword_date');
  }

  homewordPrice() {
    if (this.order.orderItems.length > 0) {
      return this.order.homewordItem.price.totalPrice();
    } else {
      return dig(this.order, 'homeword_price') || this.homeword_price;
    }
  }

  homewordDate() {
    return dig(this.order, 'homeword_date');
  }

  flightPrice() {
    const items = _.filter(this.order.orderItems, item => item.orderItemCategory === 'foreign_air');
    return _.sumBy(items, item => item.totalPriceWithAll());
  }

  flightOutwordDate() {
    return dig(this.order, 'flight_outword_date');
  }

  flightHomewordDate() {
    return dig(this.order, 'flight_homeword_date');
  }

  hotelPrice() {
    const items = _.filter(this.order.orderItems, item => item.orderItemCategory === 'hotel');
    return _.sumBy(items, item => item.totalPriceWithAll());
  }

  shinPrice() {
    const categories = ['shinkansen', 'express', 'railway_ticket'];
    const items = _.filter(this.order.orderItems, item => _.includes(categories, item.orderItemCategory));
    return _.sumBy(items, item => item.totalPriceWithAll());
  }

  airPrice() {
    const items = _.filter(this.order.orderItems, item => item.orderItemCategory === 'domestic_air');
    return _.sumBy(items, item => item.totalPriceWithAll());
  }

  otherPrice() {
    const categories = ['hotel', 'domestic_air', 'foreign_air', 'shinkansen', 'express', 'railway_ticket'];
    const items = _.filter(this.order.orderItems, item => !_.includes(categories, item.orderItemCategory));
    return _.sumBy(items, item => item.totalPriceWithAll());
  }

  shinkansenFee() {
    return dig(this.order, 'shinkansen_fee') || 0;
  }

  foreignAirFee() {
    return dig(this.order, 'foreign_air_fee') || 0;
  }

  fee() {
    const domesticAir = dig(this.order, 'domestic_air_fee') || 0;
    const foreignAir = dig(this.order, 'foreign_air_fee') || 0;
    const shin = dig(this.order, 'shinkansen_fee') || 0;
    return domesticAir + foreignAir + shin;
  }

  totalPrice() {
    return dig(this.order, 'totalPrice') + this.nonOrderItemsTotalPrice();
  }

  totalPriceWithAll() {
    return dig(this.order, 'totalPriceWithAll') || 0 + this.nonOrderItemsTotalPrice();
  }

  cancelFee() {
    return dig(this.order, 'cancelFee');
  }

  nonOrderItemsTotalPrice(types) {
    if (types == null) {
      types = [];
    }
    if (this.nonOrderItems) {
      const items =
        types.length === 0 ? this.nonOrderItems : _.filter(this.nonOrderItems, item => item.isElementTypes(types));
      if (items.length > 0) {
        return _.map(items, item => item.totalPrice()).reduce((res, ele) => res + ele);
      }
    }
    return 0;
  }

  totalPricePerTraveler() {
    return Math.ceil(this.totalPrice() / this.traveledUsers().length);
  }

  hotelPricePerTraveler() {
    return Math.ceil(this.hotelPrice() / this.traveledUsers().length);
  }

  flightPricePerTraveler() {
    return Math.ceil(this.flightPrice() / this.traveledUsers().length);
  }

  airPricePerTraveler() {
    return Math.ceil(this.airPrice() / this.traveledUsers().length);
  }

  foreignAirFeePerTraveler() {
    return Math.ceil(this.foreignAirFee() / this.traveledUsers().length);
  }

  shinPricePerTraveler() {
    return Math.ceil(this.shinPrice() / this.traveledUsers().length);
  }

  shinkansenFeePerTraveler() {
    return Math.ceil(this.shinkansenFee() / this.traveledUsers().length);
  }

  otherPricePerTraveler() {
    return Math.ceil(this.otherPrice() / this.traveledUsers().length);
  }

  outwordPriceStr() {
    return formatPrice(this.outwordPrice());
  }

  homewordPriceStr() {
    return formatPrice(this.homewordPrice());
  }

  flightPriceStr() {
    return formatPrice(this.flightPrice());
  }

  hotelPriceStr() {
    return formatPrice(this.hotelPrice());
  }

  feeStr() {
    return formatPrice(this.fee());
  }

  totalPriceStr() {
    return formatPrice(this.totalPrice());
  }

  reserveDate() {
    return moment(this.receivedAt).format('YYYY-MM-DD');
  }

  outwordType() {
    const t = dig(this.order, 'outword');
    if (!t || !(t.length > 0)) {
      return;
    }
    if (t.indexOf('新幹線') > -1) {
      return 'shin';
    } else {
      return 'air';
    }
  }

  homewordType() {
    const t = dig(this.order, 'homeword');
    if (!t || !(t.length > 0)) {
      return;
    }
    if (t.indexOf('新幹線') > -1) {
      return 'shin';
    } else {
      return 'air';
    }
  }

  pastTimeInfo() {
    const now = new Date();
    const tripDate = new Date(this.last_action_at || this.updated_at);
    const millisec = now - tripDate;
    if (millisec < 1000) {
      return {
        sinceLastUpdate: 'たった今',
        longTimeNoUpdateFlg: false
      };
    } else if (millisec / 1000 < 60) {
      return {
        sinceLastUpdate: Math.floor(millisec / 1000) + '秒前',
        longTimeNoUpdateFlg: false
      };
    } else if (millisec / 1000 / 60 < 60) {
      return {
        sinceLastUpdate: Math.floor(millisec / 1000 / 60) + '分前',
        longTimeNoUpdateFlg: false
      };
    } else if (millisec / 1000 / 60 / 60 < 24) {
      return {
        sinceLastUpdate: Math.floor(millisec / 1000 / 60 / 60) + '時間前',
        longTimeNoUpdateFlg: false
      };
    } else {
      return {
        sinceLastUpdate: Math.floor(millisec / 1000 / 60 / 60 / 24) + '日前',
        longTimeNoUpdateFlg: true
      };
    }
  }

  startDate(format) {
    const d = this.order.startDate() || this.startTime;
    if (d) {
      return d.format(format || 'YYYY-MM-DD');
    } else {
      return this.checkin_date;
    }
  }

  endDate(format) {
    const d = this.order.endDate() || this.endTime;
    if (d) {
      return d.format(format || 'YYYY-MM-DD');
    } else {
      return this.checkout_date;
    }
  }

  isEnd() {
    return this.endDate() && moment(this.endDate()).isBefore(moment()) && this.status === 7;
  }

  isNotOverEndTime() {
    const t = this.cacheEndTime || this.endTime;
    if (t) {
      return t.isAfter(moment());
    } else {
      return false;
    }
  }

  isComplete() {
    return this.status === 7;
  }

  isArchived() {
    return this.isEnd() || this.isCanceled() || this.isCanceling() || this.isApprovalCanceled();
  }

  isOngoing() {
    return !this.isArchived();
  }

  isReserveRequied() {
    return this.status === 3;
  }

  isFixed() {
    return this.status === 4;
  }

  isCanceled() {
    return this.status === 5;
  }

  // おそらく、orderItem にキャンセル情報を保存したタイミングで、trip.status の値を変更して、status でtrip のキャンセル状態を
  // 判定するのが、論理的には正しいと思われるが、過去のデータとの互換性を考えると対応が大変なため、
  // 一旦 order や orderItem の状態から、当該の trip がキャンセルされたか否かを判定する関数を生やす。
  isTripCanceled() {
    return dig(this.order, 'isCanceled');
  }

  isCanceling() {
    return this.status === 6;
  }

  isFlightCanceled() {
    return this.flight_status === 6;
  }

  isHomeWordCanceled() {
    return this.homeword_status === 6;
  }

  isOutWordCanceled() {
    return this.outword_status === 6;
  }

  isHotelCanceled() {
    return this.hotel_status === 6;
  }

  isPostNumberMissing() {
    let result = false;
    _.each(this.order.orderItems, item =>
      _.each(item.elements, function (el) {
        if (el.type === 'transport' && el.isRailway() && _.isEmpty(el.postingNumber)) {
          return (result = true);
        }
      })
    );
    return result;
  }

  isAirNumbersMissing() {
    let result = false;
    _.each(this.order.orderItems, item =>
      _.each(item.elements, function (el) {
        if (el.type === 'transport' && el.isDomesticAir() && el.isAirNumbersMissing()) {
          return (result = true);
        }
      })
    );
    return result;
  }

  isTicketingRequested() {
    return this.foreign_air && this.ticketing_requested_at;
  }

  cancelFeeText() {
    if (this.isTicketingRequested()) {
      if (this.order.isTicketingExpired()) {
        return '取消料 + 5,000円';
      } else {
        return '5,000円';
      }
    } else {
      return '0円';
    }
  }

  // 旅工房版のリクエストフォーム限定の機能
  isConfirmationRequestable() {
    return this.currentOrder.traveler_confirmation_status === 'unrequested';
  }

  projectId() {
    return (
      __guard__(
        this.order.orderItems[0] != null ? this.order.orderItems[0].orderItemMappings.first() : undefined,
        x => x.projectId
      ) || null
    );
  }

  departmentId() {
    return (
      __guard__(
        this.order.orderItems[0] != null ? this.order.orderItems[0].orderItemMappings.first() : undefined,
        x => x.chargingDepartmentId
      ) || null
    );
  }

  expensesAccountTypeId() {
    return (
      __guard__(
        this.order.orderItems[0] != null ? this.order.orderItems[0].orderItemMappings.first() : undefined,
        x => x.expensesAccountTypeId
      ) || null
    );
  }

  tripReportId() {
    const tripReport = this.orderedTripReport() || this.nonOrderedTripReport();
    if (tripReport && ['approved', 'self_approved'].includes(tripReport.status)) {
      return tripReport.id;
    }
  }

  orderedTripReport() {
    let tripReport = null;
    _.each(this.order.orderItems, function (item) {
      if (!tripReport) {
        return (tripReport = dig(item, 'price', 'priceDetails', 0, 'tripReport') || null);
      }
    });
    return tripReport;
  }

  nonOrderedTripReport() {
    let tripReport = null;
    _.each(this.non_order_items, function (item) {
      if (!tripReport) {
        return (tripReport = item.trip_report || null);
      }
    });
    return tripReport;
  }

  isProjectMappingsExist() {
    return _.some(this.order.orderItems, item =>
      _.some(item.orderItemMappings.list, mapping => mapping.isProjectExist())
    );
  }

  isDepartmentMappingsExist() {
    return _.some(this.order.orderItems, item =>
      _.some(item.orderItemMappings.list, mapping => mapping.isChargingDepartmentExist())
    );
  }

  isExpensesAccountTypeMappingsExist() {
    return _.some(this.order.orderItems, item =>
      _.some(item.orderItemMappings.list, mapping => mapping.isExpensesAccountTypeExist())
    );
  }

  isProjectNonOrderItemMappingsExist() {
    return _.some(this.nonOrderItems, item =>
      _.some(item.nonOrderItemMappings, mapping => mapping.isProjectExistForNonOrderItemMappings())
    );
  }

  isDepartmentNonOrderItemMappingsExist() {
    return _.some(this.nonOrderItems, item =>
      _.some(item.nonOrderItemMappings, mapping => mapping.isChargingDepartmentExistForNonOrderItemMappings())
    );
  }

  isExpensesAccountTypeNonOrderItemMappingsExist() {
    return _.some(this.nonOrderItems, item =>
      _.some(item.nonOrderItemMappings, mapping => mapping.isExpensesAccountTypeExistForNonOrderItemMappings())
    );
  }

  checkAllExpensesAccountTypeIdDifferent() {
    let flg = false;
    const id = this.expensesAccountTypeId();
    _.each(this.order.orderItems, function (item) {
      const itemExpenseId = __guard__(item.orderItemMappings.first(), x => x.expensesAccountTypeId) || null;
      if (itemExpenseId !== id) {
        return (flg = true);
      }
    });
    return flg;
  }

  checkHasShareOrAllDeptIdDifferent() {
    let flg = false;
    const id = this.departmentId();
    _.each(this.order.orderItems, function (item) {
      const itemDeptId = __guard__(item.orderItemMappings.first(), x => x.chargingDepartmentId) || null;
      const itemDeptShareId =
        __guard__(item.orderItemMappings.first(), x1 => x1.chargingDepartmentShareId) || null;
      if (itemDeptId !== id || itemDeptShareId !== null) {
        return (flg = true);
      }
    });
    return flg;
  }

  checkHasShareOrAllProjectIdDifferent() {
    let flg = false;
    const id = this.departmentId();
    _.each(this.order.orderItems, function (item) {
      const itemProjectId = __guard__(item.orderItemMappings.first(), x => x.projectId) || null;
      const itemProjectShareId = __guard__(item.orderItemMappings.first(), x1 => x1.projectShareId) || null;
      if (itemProjectId !== id || itemProjectShareId !== null) {
        return (flg = true);
      }
    });
    return flg;
  }

  projectName() {
    return dig(this.projects.list, 0, 'name') || dig(this, 'project', 'name');
  }

  projectCode() {
    return dig(this, 'project', 'code');
  }

  internalNumber() {
    return dig(this, 'internal_number');
  }

  internalNumberPlceHolder() {
    if (this.isInternalNumberRequired) {
      return '(必須)社内稟議番号など';
    } else {
      return '(任意)社内稟議番号など';
    }
  }

  statusSt() {
    const approveStatus = dig(this.in_advance_approval, this.in_advance_approval.length - 1, 'status');
    switch (approveStatus) {
      case 0:
        return '承認待ち';
      case 1:
      case null:
        switch (this.status) {
          case 1:
            return '旅程リクエスト中';
          case 3:
            if (this.currentOrder === null && this.nonOrderItems !== null) {
              // non_order_itemのみの場合
              if (approveStatus === 1) {
                return '承認済み';
              } else {
                return '旅程作成済';
              }
            } else {
              const activeOrderItems = _.filter(this.currentOrder.order_items, item => !item.deleted_at);
              if (
                activeOrderItems.length > 0 &&
                _.every(activeOrderItems, item => item.status === 13 || item.status === 7)
              ) {
                return '手配完了';
              } else {
                return '手配中';
              }
            }
          case 4:
          case 7:
            return '手配完了';
          case 5:
          case 6:
            return 'キャンセル';
        }
        break;
      case 2:
        return '却下済み';
      case 3:
        return 'キャンセル';
    }
  }

  statusAtApproval(i) {
    switch (dig(this.in_advance_approval, i, 'status')) {
      case 0:
        return '承認前';
      case 1:
        return '承認済み';
      case 2:
        return '却下済み';
      case 3:
        return 'キャンセル';
    }
  }

  approvedAt(i) {
    const approved_at = dig(this.in_advance_approval, i, 'approved_at');
    if (approved_at === null) {
      return '';
    }
    return moment(approved_at).tz('Asia/Tokyo').format('YYYY年MM月DD日HH時mm分');
  }

  rejectedAt(i) {
    const rejected_at = dig(this.in_advance_approval, i, 'rejected_at');
    if (rejected_at === null) {
      return '';
    }
    return moment(rejected_at).tz('Asia/Tokyo').format('YYYY年MM月DD日HH時mm分');
  }

  submittedApproverLength() {
    return _.filter(this.in_advance_approval, app => app.status !== 0).length;
  }

  hasRejected() {
    return _.filter(this.in_advance_approval, app => app.status === 2).length > 0;
  }

  createdAt(format) {
    return moment(this.created_at)
      .tz('Asia/Tokyo')
      .format(format || 'YYYY年MM月DD日HH時mm分');
  }

  cenceldAt() {
    if (this.canceled_at) {
      return moment(this.canceled_at).format('YYYY-MM-DD');
    } else if (this.status === 5) {
      return moment(this.updated_at).format('YYYY-MM-DD');
    } else {
      return '';
    }
  }

  setProject(p) {
    if (p) {
      this.projects.list[0] = p;
    } else {
      this.projects.list = [];
    }
    return app.render();
  }

  setDepartment(d) {
    this.departments = d ? [d] : [];
    return app.render();
  }

  setInternalNumber(number) {
    this.internalNumber = number;
    return app.render();
  }

  setFinalDestination(finalDestination) {
    this.final_destination = finalDestination;
    return app.render();
  }

  setPurpose(purpose) {
    this.purpose = purpose;
    return app.render();
  }

  setBakurakuWorkflowRequest(bakurakuWorkflowRequestId, bakurakuWorkflowRequestTitle, bakurakuWorkflowRequestNum) {
    this.bakurakuWorkflowRequestId = bakurakuWorkflowRequestId || '';
    this.bakurakuWorkflowRequestTitle = bakurakuWorkflowRequestTitle || '';
    this.bakurakuWorkflowRequestNum = bakurakuWorkflowRequestNum || '';
    return app.render();
  }

  setHotelReserveUrl(url) {
    this.hotel_reserve_url = url;
    return app.render();
  }

  updateParams() {
    const ids = _.compact(_.map(this.projects.list, p => p.id));
    return { project_ids: ids };
  }

  isApproveCanceled() {
    return _.find(this.in_advance_approval, in_advance_approval => in_advance_approval.status === 3);
  }

  currentApprover(user_id) {
    const approversStage = this.approvers
      .filter(approver => approver.id === user_id)
      .map(approver => approver.approve_stage);
    const in_advance_approval = this.in_advance_approval.filter(iaa => approversStage.includes(iaa.approve_stage));
    if (!in_advance_approval.length) {
      return this.in_advance_approval.length - 1;
    }
    return this.in_advance_approval.indexOf(_.maxBy(in_advance_approval, 'approve_stage'));
  }

  currentApprovedApprover(num) {
    const approver_id = dig(this.in_advance_approval[num], 'approver_id');
    return _.find(this.approved_member, approver => approver.id === approver_id);
  }

  approvedName(num) {
    if (dig(this.approved_member[num], 'name')) {
      return dig(this.approved_member[num], 'name');
    } else {
      return 'AI Travel';
    }
  }

  nextStageApprovers(approve_stage) {
    const nextApprovers = _.filter(this.approvers, approver => approver.approve_stage === approve_stage + 1);
    if (!_.isEmpty(nextApprovers)) {
      return _.map(nextApprovers, nextApprovers => nextApprovers.name);
    }
  }

  isBackStageApprover(user_id) {
    const approvers = this.approvers.filter(approver => approver.id === user_id);
    if (!approvers.length) {
      return false;
    }
    const minApproveStage = _.minBy(approvers, 'approve_stage').approve_stage;
    const lastIndex = this.in_advance_approval.length - 1;
    return this.in_advance_approval[lastIndex].approve_stage < minApproveStage;
  }

  approvalStatus(num) {
    return dig(this.in_advance_approval, num, 'status');
  }

  tripDetailEditable() {
    return !this.in_advance_approval || !dig(this.in_advance_approval, 0, 'status');
  }

  currentApprovalStatus() {
    if (_.isEmpty(this.currentUser) && this.in_advance_approval) {
      return this.approvalStatus(this.in_advance_approval.length - 1);
    }
    return this.approvalStatus(this.currentApprover(this.currentUser.id));
  }

  isHotelCheckinExpired() {
    let expired = false;
    _.each(this.order.orderItems, function (item) {
      // _.each の中で、
      // return はcontinue
      // return false はbreak
      if (item.orderItemCategory !== 'hotel') {
        return;
      }
      if (!item.elements || !(item.elements.length > 0)) {
        return;
      }
      const el = item.elements[0];
      if (!el.checkinDate) {
        return;
      }

      if (el.tooLate || !moment().isSameOrBefore(el.checkinDate, 'day')) {
        expired = true;
        return false;
      }
    });

    return expired;
  }

  flightTooLateError() {
    return !_.isEmpty(this.flight_approve_expired_at) && moment().isSameOrAfter(this.flight_approve_expired_at);
  }

  isApproved(num) {
    return this.approvalStatus(num) === 1;
  }

  isRejected(num) {
    return this.approvalStatus(num) === 2;
  }

  isApprovalCanceled(num) {
    return this.approvalStatus(num) === 3;
  }

  isOrderCanceled() {
    return this.order.status === 3;
  }

  approveReason(num) {
    return dig(this.in_advance_approval[num], 'approve_reason');
  }

  rejectReason(num) {
    return dig(this.in_advance_approval[num], 'reject_reason');
  }

  cancelReason() {
    const cancelApproval = _.find(this.in_advance_approval, i => i.status === 3);
    return cancelApproval.cancel_reason;
  }

  approvalChannelId() {
    if (this.approval_channel_id != null) {
      return this.approval_channel_id;
    }
    const checkedApproval = _.last(_.sortBy(this.in_advance_approval, 'id'));
    if ((checkedApproval != null ? checkedApproval.status : undefined) === 1) {
      return checkedApproval.approval_channel_id;
    }
  }

  approverName() {
    return dig(_.last(this.in_advance_approval), 'approver', 'name');
  }

  seatName() {
    switch (this.sheet) {
      case 'free':
        return '自由席';
      case 'reserve':
        return '指定席';
      case 'green':
        return 'グリーン席';
      case 'bulk_ticket':
        return '回数券';
    }
  }

  oldTotalPrice() {
    return (dig(this.firstOrder, 'totalPrice') || this.appliedOrder.totalPrice()) + this.nonOrderItemsTotalPrice();
  }

  didTotalPriceChange() {
    return this.oldTotalPrice() !== this.totalPrice();
  }

  isSnoozing() {
    let snoozing = false;
    if (this.snoozedTodos) {
      _.each(this.snoozedTodos, function (todo) {
        if (todo.isSnoozing()) {
          snoozing = true;
          return;
        }
      });
    }
    return snoozing;
  }

  currentSnooze() {
    let snooze = null;
    if (this.snoozedTodos) {
      _.each(this.snoozedTodos, function (todo) {
        if (todo.isSnoozing()) {
          snooze = todo;
          return;
        }
      });
    }
    return snooze;
  }

  chargingDepartmentsName() {
    if (_.isEmpty(this.departments)) {
      return '未設定';
    } else {
      return this.departments[0].name;
    }
  }

  setShowDepartmentDetail(status) {
    this.showDepartmentDetail = status;
    return app.render();
  }

  setShowProjectDetail(status) {
    this.showProjectDetail = status;
    return app.render();
  }

  setShowExpenseDetail(status) {
    this.showExpenseDetail = status;
    return app.render();
  }

  isEditableForUser() {
    // 最初の承認がなされた時点で編集不可とする
    const firstApprovalStatus = this.approvalStatus(0);
    return ![1, 2, 3].includes(firstApprovalStatus); // 承認前、承認なしの場合に編集可能
  }

  getChargingDepartmentIDs() {
    const ids = [];
    this.departments.forEach(department => ids.push(department.id));
    return ids;
  }

  initialOrderItemFor(orderItem) {
    const initialOrder = this.approvedOrder || this.firstOrder;
    return initialOrder.orderItems.find(item => item.traceId === orderItem.traceId);
  }

  isOrderItemModified(orderItem, ...path) {
    const initialItem = this.initialOrderItemFor(orderItem);
    const diff = orderItem.diffWith(initialItem);
    // 右ナビでorder_itemを追加した場合はinitialOrderItemが存在せず、orderItemDiffもない
    // したがってその場合は全項目変更されたものとする
    if (diff) {
      return _.has(diff, path);
    }
    return true;
  }

  isAllDone() {
    if (this.status !== 7) {
      return false;
    }

    let result = false;
    _.each(this.order.orderItems, function (item) {
      if (item.status === 7) {
        return (result = true);
      }
    });
    return result;
  }

  isAllOrderItemStatusComplete() {
    const noncompletelist = this.order.orderItems.filter(item => item.status !== 13 && item.status !== 7);
    return noncompletelist.length === 0;
  }
}
Trip.initClass();

module.exports = Trip;

function __guard__(value, transform) {
  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
}
